module.exports = __webpack_public_path__ + "83a64bf605264a89bb297866ff1604aa.pdf";